import dynamic from "next/dynamic";
/*
 * data fetchのsuspense化がSSRで動作しないため、CSRを強制する
 * https://itandi.esa.io/posts/5474
 */
export const PATH = "/contracts";

const NoSSR = dynamic<Empty>(
	() =>
		import("../../components/pages/contracts").then((mod) => mod.PageComponent),
	{
		ssr: false
	}
);

function Page() {
	return <NoSSR />;
}

export default Page;
